import React from "react";
import { formatMonto } from "../../utils";
import StatusBadge from "../global/StatusBadge";
import AccessBadge from "../memberships/AccessBadge";
import { getVideoDeadline } from "../../utils/course";
import { getLocationName } from "../../utils/location";
import moment from "moment";

const PurchaseCard = ({ purchase }) => {
  const course_accesses = Array.isArray(purchase.course_accesses)
    ? purchase.course_accesses
    : [];

  const renderCourse = () => {
    const { product } = purchase;
    if (!product || product === null) return;
    let name = product.name;
    if (product.mode && product.mode !== null) {
      name += ` ${product.mode === "live" ? "En vivo" : product.mode}`;
    }
    if (product.location && product.location !== null) {
      name += ` - ${getLocationName(product.location)}`;
    }
    return name;
  };

  const renderAccesses = () => {
    if (course_accesses.length === 0) {
      return <span className="text-muted small">Sin accesos</span>;
    }
    return course_accesses
      .slice()
      .sort((a, b) => parseInt(a.course_id) - parseInt(b.course_id))
      .map((course_access) => course_access.course?.name)
      .filter((name) => name)
      .join(", ");
  };

  // Every access from a purchase normally expires on the same day; if they
  // ever differ, the purchase is vigente until the last one ends.
  const renderVigencia = () => {
    const latest = course_accesses.reduce((furthest, course_access) => {
      if (!furthest) return course_access;
      return getVideoDeadline(course_access).isAfter(getVideoDeadline(furthest))
        ? course_access
        : furthest;
    }, null);
    if (!latest) return;
    return <AccessBadge course_access={latest} />;
  };

  return (
    <tr>
      <td className="">#{purchase.purchase_id}</td>
      <td className="">
        {moment(purchase.createdAt).format("DD MMM YYYY HH:mm")}
      </td>
      <td className="">
        <StatusBadge status={purchase.status} />
      </td>
      <td className="">{renderCourse()}</td>
      <td className="">
        {"$"}
        {formatMonto(purchase.amount)} {"MXN"}
      </td>
      <td className="">{renderAccesses()}</td>
      <td className="">{renderVigencia()}</td>
    </tr>
  );
};

export default PurchaseCard;
